import trackingEvents from 'app-components/utils/core/tracker/events';

type LaunchDarklyEventClient = {
  track: (key: string, data?: Record<string, string | number>, metricValue?: number) => void;
};

const isPositiveInteger = (value: unknown): value is number =>
  typeof value === 'number' && Number.isInteger(value) && value > 0;

export const trackLaunchDarklyEvent = (
  client: LaunchDarklyEventClient | undefined,
  event: string,
  properties: unknown,
): void => {
  if (!client) return;

  // Start with receipt events; only explicitly mapped events and properties go to LaunchDarkly.
  switch (event) {
    case trackingEvents.receiptUploadStaged: {
      if (!properties || typeof properties !== 'object') return;
      const { fileCount, stagedFileCount } = properties as Record<string, unknown>;
      if (!isPositiveInteger(fileCount) || !isPositiveInteger(stagedFileCount)) return;
      client.track(event, { fileCount, stagedFileCount });
      return;
    }
    case trackingEvents.receiptUploadConfirmed:
    case trackingEvents.receiptUploadCancelled: {
      if (!properties || typeof properties !== 'object') return;
      const { fileCount } = properties as Record<string, unknown>;
      if (!isPositiveInteger(fileCount)) return;
      client.track(event, { fileCount });
      return;
    }
    case trackingEvents.receiptUploadSubmitted: {
      if (!properties || typeof properties !== 'object') return;
      const { fileCount, flow } = properties as Record<string, unknown>;
      if (!isPositiveInteger(fileCount)) return;
      if (flow !== 'immediate' && flow !== 'confirm-before-upload') return;
      client.track(event, { fileCount, flow }, fileCount);
      return;
    }
    case trackingEvents.receiptProcessingResult: {
      if (!properties || typeof properties !== 'object') return;
      const { stage, result } = properties as Record<string, unknown>;
      if (stage !== 'upload') return;
      if (result === 'success') client.track('receiptUploadSucceeded');
      if (result === 'failed') client.track('receiptUploadFailed');
      return;
    }
    default:
      return;
  }
};
